import { createFileRoute } from "@tanstack/react-router";
import { ReelsPage } from "../../../features/reels";
import type { ReelsPageSearch } from "../../../features/reels/pages/reels-page";

export type ReelsSearch = ReelsPageSearch;

export const Route = createFileRoute("/$lang/_layout/reels")({
  component: ReelsPage,
  /**
   * What the guest has open lives in the URL so Back, refresh, a shared link
   * and the language switch keep it: `category` is the row open as a See all
   * grid, `v` the video playing. Anything that is not a string is dropped.
   */
  validateSearch: (search: Record<string, unknown>): ReelsSearch => {
    const category = typeof search.category === "string" ? search.category : undefined;
    const v = typeof search.v === "string" ? search.v : undefined;
    return { ...(category ? { category } : {}), ...(v ? { v } : {}) };
  },
});
